/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

/* ===========================================================================
   Goodbean - Lager-Hinweis (stock-note): Text je nach Produkttyp
   -------------------------------------------------------------
   Kaffee-Produkte (Produkttyp "Coffee") zeigen einen eigenen Text,
   alle anderen den Standard-Text.  (Die OPTIK liegt in assets/gb-global.css.)
   >>> TEXTE HIER AENDERN: <<<
=========================================================================== */
window.GB_STOCK_NOTE = {
  // Text fuer normale Produkte (Zubehoer etc.)
  standard: 'Auf Lager',
  // Text fuer Kaffee-Produkte (Produkttyp "Coffee")
  kaffee: 'Ist vorrätig oder wird frisch für dich geröstet'
};

(function () {
  // Nur auf Produktseiten aktiv
  if (location.pathname.indexOf('/products/') < 0) return;

  function desired() {
    var t = '';
    try { t = ShopifyAnalytics.meta.product.type || ''; } catch (e) {}
    return (t === 'Coffee') ? window.GB_STOCK_NOTE.kaffee : window.GB_STOCK_NOTE.standard;
  }

  function swap() {
    var el = document.querySelector('.product-single__box__block--inventory_notice .stock-note--in-stock:not(.stock-note--low) .stock-note__text');
    if (!el) return false;
    var txt = desired();
    if (txt && el.textContent.trim() !== txt) el.textContent = txt;
    return true;
  }

  function start() {
    var n = 0;
    var iv = setInterval(function () { swap(); if (n++ > 40) clearInterval(iv); }, 250);
    document.addEventListener('change', function () { setTimeout(swap, 80); });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();


/* ===========================================================================
   Goodbean - Vorbestell-Hinweis im Warenkorb (Adventskalender 2026)
   Zeigt im Cart-Drawer und auf /cart eine Zeile, sobald ein Produkt mit dem
   Handle unten im Warenkorb liegt. Text hier aendern:
=========================================================================== */
window.GB_PREORDER_NOTE = {
  handles: ['kaffee-adventskalender'],
  text: 'Enthaelt eine Vorbestellung: Alles andere schicken wir sofort, den Adventskalender ab 17. November als zweite Sendung, ohne Aufpreis.'
};

(function () {
  var cfg = window.GB_PREORDER_NOTE;
  if (!cfg || !cfg.handles || !cfg.handles.length) return;
  var busy = false;

  function render(show) {
    var hosts = document.querySelectorAll('cart-contents, .cart__contents, .cart-page .cart__wrapper');
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      var el = host.querySelector('.gb-preorder-note');
      if (show && !el) {
        el = document.createElement('div');
        el.className = 'gb-preorder-note';
        el.textContent = cfg.text;
        host.insertBefore(el, host.firstChild);
      } else if (!show && el) {
        el.parentNode.removeChild(el);
      }
    }
  }

  function check() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hit = false;
        (cart.items || []).forEach(function (it) {
          if (cfg.handles.indexOf(it.handle) >= 0) hit = true;
        });
        render(hit);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function start() {
    var st = document.createElement('style');
    st.textContent = '.gb-preorder-note{margin:0 0 12px;padding:10px 12px;background:#FFF8D6;border-left:4px solid #F6C800;border-radius:8px;font-size:13px;line-height:1.45;color:#111}';
    document.head.appendChild(st);
    check();
    document.addEventListener('cart:updated', check);
    document.addEventListener('cart:refresh', check);
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[data-cart-toggle], .js-cart-toggle, .cart-link, [href="/cart"], button[name="add"]')) setTimeout(check, 900);
    });
    setInterval(check, 4000);
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();